import type { TimelineBlock } from "../contract/types";
import { Icon } from "../components/Icon";
import type { BlockViewProps } from "./types";

/**
 * Secuencia ordenada: el cronograma de 8 semanas, los pasos de un proceso.
 *
 * El estado (hecho / en curso / pendiente) no se comunica solo con color:
 * cada hito lleva su etiqueta escrita, y el actual va marcado con un anillo.
 */

const STATUS_LABEL: Record<"done" | "current" | "upcoming", string> = {
  done: "Completado",
  current: "En curso",
  upcoming: "Pendiente",
};

export function Timeline({ block }: BlockViewProps<TimelineBlock>) {
  const items = block.items ?? [];
  const orientation = block.orientation ?? "vertical";

  if (items.length === 0) {
    return <p className="atom__empty">La línea de tiempo no trae hitos.</p>;
  }

  return (
    <ol className={`atom atom--timeline timeline timeline--${orientation}`}>
      {items.map((item, index) => {
        const status = item.status ?? "upcoming";
        return (
          <li key={`${item.label}-${index}`} className={`timeline__item timeline__item--${status}`}>
            <div className="timeline__marker" aria-hidden="true">
              {status === "done" ? <Icon name="check" size="0.625rem" /> : null}
            </div>
            <div className="timeline__card">
              <div className="timeline__head">
                <span className="timeline__label">{item.label}</span>
                <span className={`timeline__status timeline__status--${status}`}>
                  {STATUS_LABEL[status]}
                </span>
              </div>
              <h4 className="timeline__title">{item.title}</h4>
              {item.description ? (
                <p className="timeline__description">{item.description}</p>
              ) : null}
              {item.duration || (item.tags && item.tags.length > 0) ? (
                <div className="timeline__foot">
                  {item.duration ? (
                    <span className="timeline__duration">
                      <Icon name="clock" size="0.75rem" />
                      {item.duration}
                    </span>
                  ) : null}
                  {item.tags?.map((tag) => (
                    <span key={tag} className="timeline__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              ) : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default Timeline;
